import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RenameCompanyComponent } from '.';
import { DxDataGridModule, DxTemplateModule, DxButtonModule, DxTextBoxModule, DxValidatorModule } from 'devextreme-angular';
import { RenameMasterBrandComponent } from './rename-master-brand/rename-master-brand.component';
import { RenameBrandComponent } from './rename-brand/rename-brand.component';
import { RenameSubBrandComponent } from './rename-sub-brand/rename-sub-brand.component';
import { RenameProductComponent } from './rename-product/rename-product.component';

@NgModule({
  imports: [
	CommonModule,
	DxDataGridModule,
	DxTemplateModule,
	DxButtonModule,
	DxTextBoxModule,
	DxValidatorModule,
  ],
  declarations: [
	RenameCompanyComponent,
	RenameMasterBrandComponent,
	RenameBrandComponent,
	RenameSubBrandComponent,
	RenameProductComponent
  ]
})
export class RenamePopupsModule { }
